<template>
  <span class="modalcomponent">
    <a-modal v-model="modalVisible" :title="title" :dialogStyle="dialogStyle" :width="width" :zIndex="zIndex" :maskClosable="maskClosable" @ok="handleOk" :footer="$slots.buttons || null">      
      <slot></slot>
    </a-modal>
  </span>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Title',
        },
        width: {
            type: String,
            default: '100%',
        },
        zIndex: {
            type: Number,
            default: 1000,
        },
        dialogStyle: {
            type: Object,
            default: () => ({}),
        },
        maskClosable: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            loading: false,
            modalVisible: this.visible,
        };
    },
    methods: {
        showModal() {
            this.modalVisible = true;
        },
        handleCancel() {            
            this.modalVisible = false;
        },
        handleOk() {
            this.modalVisible = false;
        },
    }
};
</script>